module.exports = __webpack_public_path__ + "img/color_spring_clothes_square.315e1896.png";